import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Institution14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.33542 0.82918C7.12427 0.723607 6.87574 0.723607 6.6646 0.82918L0.664599 3.82918C0.214279 4.05434 0.11367 4.67432 0.469679 5.03033L1.75 6.31065V11.25H0V12.75H14V11.25H12.25V6.31067L13.5303 5.03033C13.8863 4.67432 13.7857 4.05434 13.3354 3.82918L7.33542 0.82918ZM10.75 6.75H9.25V11.25H10.75V6.75ZM7.75 6.75H6.25V11.25H7.75V6.75ZM4.75 6.75H3.25V11.25H4.75V6.75ZM2.81067 5.25L2.26613 4.70546L7.00001 2.33853L11.7339 4.70546L11.1894 5.25H2.81067Z'
      fill='currentColor'
    />
  </Svg>
);

Institution14.displayName = 'Institution14';
export default Institution14;
